// Angular
import { Injectable } from '@angular/core';

// Interfaces
import { INewRegion, IRegion, IUpdatedRegion } from '../../interfaces/seacom/region';

// Services
import { ApiNodeService } from './templates/apinode.service';
import { SeacomApiService } from './seacom-api.service';


@Injectable({
  providedIn: 'root'
})
export class RegionsService extends ApiNodeService<IRegion, INewRegion, IUpdatedRegion> {
  node = 'regions';

  constructor(public seacomApiService: SeacomApiService) {
    super(seacomApiService);
  }

}
